import { WalkThroughControl } from '../controls';
import * as marietta from '../../marietta';

export default class ControlButton {
  private _el: any;

  _right: number;

  _bottom: number;

  _imgSrc: string;

  _container: HTMLElement;

  _wtCtrl: WalkThroughControl;

  _target: any;

  constructor(id: string, right: number, bottom: number, imgSrc: string, container: HTMLElement, control: WalkThroughControl) {
    // このインスタンスのメインコンテナ
    this._right = right;
    this._wtCtrl = control;
    this._bottom = bottom;

    this._el = document.createElement('div');
    this._el.id = id;
    this._el.style.position = 'fixed';
    this._el.style.padding = 0;
    this._el.style.margin = 0;
    this._el.style.opacity = 0.5;
    this._el.style.cursor = 'pointer';
    this._el.style.right = `${this._right}px`;
    this._el.style.bottom = `${this._bottom}px`;
    this._el.style.overflow = 'hidden';
    container.appendChild(this._el);
    // canvas にボタンのグラフィックを描画
    const img:any = new Image();
    img.src = imgSrc;
    const scope: ControlButton = this;
    img.onload = () => {
      // canvas を作成
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      scope._el.appendChild(canvas);
      // マウスイベント
      if (marietta.view3d.base.Config.me.isTouchMode(scope._el)) {
        canvas.addEventListener('touchstart', scope.onTouchStart, { passive: false });
        canvas.addEventListener('touchend', scope.onTouchEnd, { passive: false });
      } else {
        canvas.addEventListener('mousedown', scope.onMouseDown, false);
        canvas.addEventListener('mouseup', scope.onMouseUp, false);
        canvas.addEventListener('mouseout', scope.onMouseUp, false);
      }

      if (canvas.getContext) {
        const ctx = canvas.getContext('2d');
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        // ctx.drawImage(img,0,0);
        if (marietta.view3d.base.Config.me.isTouchMode(scope._el)) {
          ctx.drawImage(img, 0, 0);
          scope._el.style.width = `${img.width / 2}px`;
          scope._el.style.height = `${img.height / 2}px`;
        } else {
          ctx.drawImage(img, 0, 0);
          scope._el.style.width = `${img.width}px`;
          scope._el.style.height = `${img.height}px`;
        }
      }
    };
  }

  public move = () => {
    switch (this._el.id) {
      case 'bt_up':
        this._wtCtrl.btnControlSet.fwd();
        break;
      case 'bt_down':
        this._wtCtrl.btnControlSet.back();
        break;
      default:
    }
  }

  private pan = () => {
    switch (this._el.id) {
      case 'bt_left':
        this._wtCtrl.btnControlSet.panLeft();
        break;
      case 'bt_right':
        this._wtCtrl.btnControlSet.panRight();
        break;
      default:
    }
  }

  private reset = () => {
    switch (this._el.id) {
      case 'bt_home':
        marietta.view3d.webcad.View3dGlobal.shared.homeCamera();
        break;
      default:
    }
  }

  private onMouseDown = (e: any) => {
    e.preventDefault();
    this._el.style.opacity = 1;
    this.move();
    this.pan();
    this.reset();
  }

  private onTouchStart = (e: any) => {
    e.preventDefault();
    this._el.style.opacity = 1;
    this.move();
    this.pan();
    this.reset();
  }

  private onMouseUp = (e: any) => {
    e.preventDefault();
    this._el.style.opacity = 0.5;
    this._wtCtrl.btnControlSet.stop();
  }

  private onTouchEnd = (e: any) => {
    e.preventDefault();
    this._el.style.opacity = 0.5;
    this._wtCtrl.btnControlSet.stop();
  }

  public moveControl = (right: number, bottom: number) => {
    this._el.style.right = `${String(right)}px`;
    this._el.style.bottom = `${String(bottom)}px`;
  }

  public visible = (val: any) => {
    this._el.style.visibility = val ? '' : 'hidden';
  }
}
